// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { LMimages, LMMediadata } from './types';
import { LMMediaResponse } from './types';

export interface ActionGetLMImagesAPI extends Action {
    listingId: string
}

export const getLMImagesAPI = (listingId: string): ActionGetLMImagesAPI => ({
    type: ACTIONS.GET_LMIMAGES_API_REQUEST,
    listingId,
});

export interface ActionGetLMImagesAPISuccess extends Action {
    lmimages: LMimages
}

export const getLMImagesAPISuccess = (lmimages: LMimages): ActionGetLMImagesAPISuccess => ({
    type: ACTIONS.GET_LMIMAGES_API_SUCCESS,
    lmimages
});

export const getLMImagesAPIError = (): Action => ({
    type: ACTIONS.GET_LMIMAGES_API_ERROR,
});


export interface ActionPostLMImagesAPI extends Action {
    listingId: string
    images: LMMediadata[]
    engine?:string
}

export const postLMImagesAPI = (listingId: string, images: LMMediadata[], engine?:string): ActionPostLMImagesAPI => ({
    type: ACTIONS.POST_LMIMAGES_API_REQUEST,
    listingId,
    images,
    engine
});

export interface ActionPostLMImagesAPISuccess extends Action {
    lmMediaResponse: LMMediaResponse
}

export const postLMImagesAPISuccess = (lmMediaResponse: LMMediaResponse): ActionPostLMImagesAPISuccess => ({
    type: ACTIONS.POST_LMIMAGES_API_SUCCESS,
    lmMediaResponse
});

export const postLMImagesAPIError = (lmimages: LMimages): Action => ({
    type: ACTIONS.POST_LMIMAGES_API_ERROR,
});



